import autoText from 'autotext';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

autoText.config.classes.set({
    input: 'ui-input',
    container: 'ui-inlst',
    container_cancelable: 'ui-inlst-cancelable',
    container_opened: 'ui-inlst-active',
    container_with_form: 'ui-inlst-active__with-form',
    list: 'ui-inlst-list',
    arrow: 'ui-inlst-arrow bvi-hide',
    cancel: 'ui-inlst-cancel',
    form: 'ui-inlst-form',
});

export default autoText;
